import { render, staticRenderFns } from "./PartnerInfoStaff.vue?vue&type=template&id=6e6f44fe&scoped=true"
import script from "./PartnerInfoStaff.vue?vue&type=script&lang=js"
export * from "./PartnerInfoStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f44fe",
  null
  
)

export default component.exports